(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["circle-filter"] && !Shopify.designMode) return;
  try {
    
        function checkOverflow() {
            const customScrollbars = document.querySelectorAll(".custom-scrollbar");

            customScrollbars.forEach(customScrollbar => {
                // Check if horizontal overflow is more than the width
                const hasHorizontalOverflow = customScrollbar.scrollWidth > customScrollbar.clientWidth;

                // If there's horizontal overflow, assign justify-content as "left"
                if (hasHorizontalOverflow) {
                    customScrollbar.style.justifyContent = "left";
                } else {
                    customScrollbar.style.justifyContent = ""; // Reset justify-content if not needed
                }
            });
        }

        // Call checkOverflow function on page load
        window.addEventListener("load", checkOverflow);

        // Add event listener to handle responsive changes
        window.addEventListener("resize", checkOverflow);


  } catch(e) { console.error(e); }
})();
})();
